import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { N20, N40 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Rectangle = styled.div({
	width: '100%',
	height: `calc(100% - ${token('space.200', '16px')})`,
	borderRadius: token('border.radius.100', '3px'),
	backgroundColor: token('color.skeleton', N20),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Circle = styled.div({
	height: token('space.400', '32px'),
	width: token('space.400', '32px'),
	borderRadius: '50%',
	backgroundColor: token('color.skeleton', N20),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	display: 'flex',
	flexWrap: 'wrap',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Row = styled.div({
	display: 'grid',
	gridTemplateColumns: '40% auto 20%',
	width: '100%',
	borderTop: `1px solid ${token('color.border', N40)}`,
	padding: `${token('space.100', '8px')} 0`,
	justifyContent: 'space-between',
	alignItems: 'center',
});

export const PageTreeSkeleton = () => {
	return (
		<Wrapper data-testid="confluence-project-pages.page-tree-skeleton">
			{Array.from(Array(6), (_, index) => (
				<Row key={index}>
					<Rectangle />
					<Circle />
					<Rectangle />
				</Row>
			))}
		</Wrapper>
	);
};
